import { Route } from "@angular/router";
import { ArchivePageComponent } from "./routes/ai-bot/admin/admin-pages/archive-page/archive-page.component";
import { HomePageComponent } from "./routes/ai-bot/admin/admin-pages/projects-page/home-page/home-page.component";
import { ProjectApitokenTabComponent } from "./routes/ai-bot/admin/admin-pages/projects-page/project-apitoken-tab/project-apitoken-tab.component";
import { projectApiTokenResolver } from "./routes/ai-bot/admin/admin-pages/projects-page/project-apitoken-tab/project-apitoken.resolver";
import { ProjectDocumentsTabComponent } from "./routes/ai-bot/admin/admin-pages/projects-page/project-documents-tab/project-documents-tab.component";
import { ProjectGroupchatChannelComponent } from "./routes/ai-bot/admin/admin-pages/projects-page/project-groupchat-tab/project-groupchat-channel.component";
import { ProjectGroupchatTabComponent } from "./routes/ai-bot/admin/admin-pages/projects-page/project-groupchat-tab/project-groupchat-tab.component";
import { ProjectKeyValsTabComponent } from "./routes/ai-bot/admin/admin-pages/projects-page/project-keyvals-tab/project-keyvals-tab.component";
import { ProjectQuizTabComponent } from "./routes/ai-bot/admin/admin-pages/projects-page/project-quiz-tab/project-quiz-tab.component";
import { ProjectQuizUserComponent } from "./routes/ai-bot/admin/admin-pages/projects-page/project-quiz-tab/project-quiz-user.component";
import { ProjectSecretsTabComponent } from "./routes/ai-bot/admin/admin-pages/projects-page/project-secrets-tab/project-secrets-tab.component";
import { ProjectsPageComponent } from "./routes/ai-bot/admin/admin-pages/projects-page/projects-page.component";
import { TemplatesPageComponent } from "./routes/ai-bot/admin/admin-pages/templates-page/templates-page.component";
import { TrashPageComponent } from "./routes/ai-bot/admin/admin-pages/trash-page/trash-page.component";
import { BotAdminComponent } from "./routes/ai-bot/admin/admin.component";
import { AccessControlTabComponent } from "./routes/ai-bot/admin/tabs/general/access-control-tab/access-control-tab.component";
import { BotTaskTabComponent } from "./routes/ai-bot/admin/tabs/general/bot-task-tab/bot-task-tab.component";
import { ChangelogTabComponent } from "./routes/ai-bot/admin/tabs/general/changelog-tab/changelog-tab.component";
import { EmbedTabComponent } from "./routes/ai-bot/admin/tabs/general/embed-tab/embed-tab.component";
import { ExternalapiTabComponent } from "./routes/ai-bot/admin/tabs/general/externalapi-tab/externalapi-tab.component";
import { externalapiResolver } from "./routes/ai-bot/admin/tabs/general/externalapi-tab/externalapi.resolver";
import { InformationTabComponent } from "./routes/ai-bot/admin/tabs/general/information-tab/information-tab.component";

import { PrivacyPolicyTabComponent } from "./routes/ai-bot/admin/tabs/general/privacy-policy-tab/privacy-policy-tab.component";
import { BotEditorComponent } from "./shared/components/ai-bot/bot-editor/bot-editor.component";
import { authGuard } from "./shared/guards/auth.guard";
import { accesscontrolResolver } from "./shared/resolver/accesscontrol.resolver";
import { archiveResolver } from "./shared/resolver/archive.resolver";
import { botconfigadminResolver } from "./shared/resolver/botconfigadmin.resolver";
import { changeLogResolver } from "./shared/resolver/change-log.resolver";
import { fusionDetailResolver } from "./shared/resolver/fusion-detail.resolver";
import { fusionResolver } from "./shared/resolver/fusion.resolver";
import { projectResolver } from "./shared/resolver/project.resolver";
import { projectbotsResolver } from "./shared/resolver/projectbots.resolver";
import { datatrunkResolver } from "./shared/resolver/skills/datatrunk.resolver";
import { documentResolver } from "./shared/resolver/skills/document.resolver";
import { webscrapeResolver } from "./shared/resolver/skills/webscrape.resolver";
import { supervisorResolver, supervisorSelectResolver } from "./shared/resolver/supervisor.resolver";
import { templateResolver } from "./shared/resolver/template.resolver";
import { trashResolver } from "./shared/resolver/trash.resolver";
import { userKeyValResolver } from "./shared/resolver/user-key-val.resolver";
import { userStatisticsResolver } from "./shared/resolver/userstatistics.resolver";

export const botAdminRoute: Route =
{
  path: "bot-admin",
  pathMatch: "prefix",
  canActivate: [authGuard],
  children: [
    {
      path: "",
      component: BotAdminComponent,
      runGuardsAndResolvers: "paramsChange",
      children: [
        {
          path: "",
          component: HomePageComponent,
          resolve: {
            projects: projectResolver,
            templates: templateResolver
          }
        },
        {
          path: "templates",
          component: TemplatesPageComponent,
          resolve: {
            bots: templateResolver
          }
        },
        {
          path: "archive",
          component: ArchivePageComponent,
          resolve: {
            bots: archiveResolver
          }
        },
        {
          path: "trash",
          component: TrashPageComponent,
          resolve: {
            bots: trashResolver
          }
        },
        {
          path: "orphans",
          loadComponent: () => import("./routes/ai-bot/admin/admin-pages/orphans-page/orphans-page.component").then(m => m.OrphansPageComponent)
        },
        {
          path: "project/:projectid",
          component: ProjectsPageComponent,
          resolve: {
            projects: projectResolver,
            bots: projectbotsResolver
          },
          runGuardsAndResolvers: "paramsChange",
          children: [
            {
              path: "",
              component: HomePageComponent,
              resolve: {
                templates: templateResolver
              }
            },
            {
              path: "secrets",
              component: ProjectSecretsTabComponent
            },
            {
              path: "documents",
              component: ProjectDocumentsTabComponent
            },
            {
              path: "apitoken",
              component: ProjectApitokenTabComponent,
              resolve: [projectApiTokenResolver],
              runGuardsAndResolvers: "always"
            },
            {
              path: "keyvals",
              component: ProjectKeyValsTabComponent
            },
            {
              path: "groupchat",
              component: ProjectGroupchatTabComponent
            },
            {
              path: "groupchat/:channel",
              component: ProjectGroupchatChannelComponent
            },
            {
              path: "quiz",
              component: ProjectQuizTabComponent
            },
            {
              path: "quiz/:userId",
              component: ProjectQuizUserComponent
            }
          ]
        }
      ]
    },
    {
      path: ":id",
      component: BotEditorComponent,
      resolve: {
        selectedBot: botconfigadminResolver
      },
      runGuardsAndResolvers: "paramsChange",
      children: [
        {
          path: "",
          pathMatch: "prefix",
          redirectTo: "task"
        },
        {
          path: "information",
          component: InformationTabComponent
        },
        {
          path: "task",
          component: BotTaskTabComponent
        },
        {
          path: "config",
          loadComponent: () => import("./routes/ai-bot/admin/tabs/general/configurations-tab/configurations-tab.component").then(m => m.ConfigurationsTabComponent)
        },
        {
          path: "externalapi",
          component: ExternalapiTabComponent,
          resolve: [externalapiResolver],
          runGuardsAndResolvers: "always"
        },
        {
          path: "chatbot",
          loadComponent: () => import("./routes/ai-bot/admin/tabs/general/configurations-tab/chatbot-tab/chatbot-tab.component").then(m => m.ChatbotTabComponent)
        },
        {
          path: "fusionbot",
          resolve: [fusionResolver],
          children: [
            {
              path: '',
              loadComponent: () => import("./routes/ai-bot/admin/tabs/general/configurations-tab/fusionbot-tab/fusionbot-tab.component").then(m => m.FusionbotTabComponent)
            },
            {
              path: ':fusionid',
              loadComponent: () => import("./routes/ai-bot/admin/tabs/general/configurations-tab/fusionbot-tab/fusion-bot-detatail/fusion-bot-detatail.component").then(m => m.FusionBotDetatailComponent),
              resolve: [fusionDetailResolver]
            }
          ]
        },
        {
          path: "voicebot",
          loadComponent: () => import("./routes/ai-bot/admin/tabs/general/configurations-tab/voicebot-tab/voicebot-tab.component").then(m => m.VoicebotTabComponent)
        },
        {
          path: "avatar-nova",
          loadComponent: () => import("./routes/ai-bot/admin/tabs/general/configurations-tab/avatar-tab/avatar-tab.component").then(m => m.AvatarTabComponent)
        },
        {
          path: "avatar-vega",
          loadComponent: () => import("./routes/ai-bot/admin/tabs/general/configurations-tab/did-avatar-tab/did-avatar-tab.component").then(m => m.DIdAvatarTabComponent)
        },
        { path: "avatar", pathMatch: "full", redirectTo: "avatar-nova" },
        { path: "did-avatar", pathMatch: "full", redirectTo: "avatar-vega" },
        {
          path: "privacy-policy",
          component: PrivacyPolicyTabComponent
        },
        {
          path: "stage-manager",
          loadComponent: () => import("./routes/ai-bot/admin/tabs/general/configurations-tab/stage-manager/stage-manager.component").then(m => m.StageManagerComponent)
        },
        {
          path: "access-control",
          component: AccessControlTabComponent,
          resolve: [accesscontrolResolver],
          runGuardsAndResolvers: "always"
        },
        {
          path: "blockly",
          loadComponent: () => import("./routes/ai-bot/admin/tabs/general/blockly-tab-fullscreen/blockly-tab-fullscreen.component").then(m => m.BlocklyTabFullscreenComponent)
        },
        {
          path: "embed",
          component: EmbedTabComponent
        },
        {
          path: "changelog",
          component: ChangelogTabComponent,
          resolve: [changeLogResolver],
          runGuardsAndResolvers: "always"
        },
        {
          path: "if-then",
          loadComponent: () => import("./routes/ai-bot/admin/tabs/skills/ifthen-tab/ifthen-tab.component").then(m => m.IfthenTabComponent)
        },
        {
          path: "documents",
          runGuardsAndResolvers: "always",
          resolve: {
            documents: documentResolver
          },
          children: [
            {
              path: "",
              loadComponent: () => import("./routes/ai-bot/admin/tabs/skills/documents-tab/documents-tab.component").then(m => m.DocumentsTabComponent)
            },
            {
              path: ":docid",
              loadComponent: () => import("./routes/ai-bot/admin/tabs/skills/documents-tab/documents-tab-detail/documents-tab-detail.component").then(m => m.DocumentsTabDetailComponent)
            }
          ]
        },
        {
          path: "user-docs",
          loadComponent: () => import("./routes/ai-bot/admin/tabs/skills/user-docs-tab/user-docs-tab.component").then(m => m.UserDocsTabComponent)
        },
        {
          path: "online-sources",
          loadComponent: () => import("./routes/ai-bot/admin/tabs/skills/online-sources-tab/online-sources-tab.component").then(m => m.OnlineSourcesTabComponent)
        },
        {
          path: "databases",
          runGuardsAndResolvers: "always",
          resolve: {
            dataTrunks: datatrunkResolver
          },
          loadComponent: () => import("./routes/ai-bot/admin/tabs/skills/databases-tab/databases-tab.component").then(m => m.DatabasesTabComponent)
        },
        {
          path: "offline-websites",
          runGuardsAndResolvers: "always",
          resolve: {
            webscrapes: webscrapeResolver
          },
          loadComponent: () => import("./routes/ai-bot/admin/tabs/skills/offline-websites-tab/offline-websites-tab.component").then(m => m.OfflineWebsitesTabComponent)
        },
        {
          path: "memory",
          loadComponent: () => import("./routes/ai-bot/admin/tabs/insights/memory-tab/memory-tab.component").then(m => m.MemoryTabComponent)
        },
        {
          path: "supervisor",
          resolve: {
            historyItems: supervisorResolver
          },
          children: [
            {
              path: "",
              loadComponent: () => import("./routes/ai-bot/admin/tabs/insights/supervisor-tab/supervisor-tab.component").then(m => m.SupervisorTabComponent)
            },
            {
              path: "functions",
              children: [
                {
                  path: "",
                  loadComponent: () => import("./routes/ai-bot/admin/tabs/insights/supervisor-tab/supervisor-functions/supervisor-functions.component").then(m => m.SupervisorFunctionsComponent)
                },
                {
                  path: ":functionid",
                  loadComponent: () => import("./routes/ai-bot/admin/tabs/insights/supervisor-tab/supervisor-functions/supervisor-functions-details/supervisor-functions-details.component").then(m => m.SupervisorFunctionsDetailsComponent)
                }
              ]
            },
            {
              path: ":thread",
              resolve: {
                historyItems: supervisorSelectResolver
              },
              loadComponent: () => import("./routes/ai-bot/admin/tabs/insights/supervisor-tab/supervisor-tab.component").then(m => m.SupervisorTabComponent)
            }
          ]
        },
        {
          path: "feedback",
          loadComponent: () => import("./routes/ai-bot/admin/tabs/insights/feedback-tab/feedback-tab.component").then(m => m.FeedbackTabComponent)
        },
        {
          path: "statistics",
          loadComponent: () => import("./routes/ai-bot/admin/tabs/insights/statistics-tab/statistics-tab.component").then(m => m.StatisticsTabComponent)
        },
        {
          path: "latency",
          loadComponent: () => import("./routes/ai-bot/admin/tabs/insights/latency-tab/latency-tab.component").then(m => m.LatencyTabComponent)
        },
        {
          path: "webhooks",
          loadComponent: () => import("./routes/ai-bot/admin/tabs/skills/webhooks-tab/webhooks-tab.component").then(m => m.WebhooksTabComponent)
        },
        {
          path: "mcp-server",
          children: [
            {
              path: "",
              loadComponent: () => import("./routes/ai-bot/admin/tabs/skills/mcp-server-tab/mcp-server-tab.component").then(m => m.McpServerTabComponent)
            }
          ]
        },
        {
          path: 'uservalues',
          loadComponent: () => import("./routes/ai-bot/admin/tabs/insights/user-values-tab/user-values-tab.component").then(m => m.UserValuesTabComponent),
          resolve: { data: userKeyValResolver }
        },
        {
          path: 'userstatistics',
          loadComponent: () => import("./routes/ai-bot/admin/tabs/insights/userstatistics-tab/userstatistics-tab.component").then(m => m.UserstatisticsTabComponent),
          resolve: { stats: userStatisticsResolver }
        }
      ]
    }
  ]
};
